define(['../../core/core.js', '../../util/util'], function(core, util) {
    'use strict';
    var isSafari = (function() {
        var ua = navigator.userAgent.toLowerCase();
        var match = /(chrome)[ \/]([\w.]+)/.exec(ua) ||
            /(webkit)[ \/]([\w.]+)/.exec(ua) ||
            /(opera)(?:.*version|)[ \/]([\w.]+)/.exec(ua) ||
            /(msie) ([\w.]+)/.exec(ua) ||
            ua.indexOf("compatible") < 0 && /(mozilla)(?:.*? rv:([\w.]+)|)/.exec(ua) || [];
        return match[1] === 'webkit';
    })();

    var download = function(container, fileName, url) {
        var $container = container.jquery ? container : $(container);
        var $downloadLink = $('<a></a>').appendTo($container);
        $downloadLink.attr('href', url);
        $downloadLink.attr('download', fileName);
        $downloadLink.attr('target', '_blank');
        setTimeout(function() {
            $downloadLink[0].click();
            $downloadLink.remove();
        }, 0);
    };

    // var downloadForSafari = function(content) {
    //     var rowData = content.rowData;
    //     var params = {
    //         url: core.getQSPath() + 'ra/export',
    //         ept: 'CSV',
    //         fileName: content.fileName,
    //         delimiter: ';',
    //         content: JSON.stringify({
    //             sheets: [{
    //                 sheetName: content.fileName,
    //                 headers: ['date'],
    //                 datas: [
    //                     ['aaa']
    //                 ]
    //             }]
    //         })
    //     };
    //     core.Util.openWindowWithPost(params);
    // };

    var convertCSVData = function(content) {
        var dataLength = 0,
            csvString = '',
            rowData = content.rowData;
        for (var i = 0; i < rowData.length; i++) {
            dataLength = rowData[i].length > dataLength ? rowData[i].length : dataLength;
        }
        for (var i = 0; i < dataLength; i++) {
            var rowString = '';
            for (var r = 0; r < rowData.length; r++) {
                var tempStr = rowData[r][i];
                if (util.endwith(tempStr, content.delimiter)) {
                    if (r !== rowData.length - 1) {
                        tempStr += content.delimiter;
                    }
                } else if (r !== rowData.length - 1) {
                    tempStr += (content.delimiter + content.delimiter);
                }
                rowString += tempStr;
            }
            rowString += '\r\n';
            csvString += rowString;
        }
        return csvString;
    };

    var createFile = function(container, content) {
        var result = convertCSVData(content);
        if (!Blob) {
            throw (new Error('Blob is not supported by your browser'));
        }
        result = '\ufeff' + result;

        var blob = new Blob([result], {
            type: 'text/csv;charset=utf-8;'
        });

        var fileName = content.fileName + '.csv';

        if (window.navigator.msSaveOrOpenBlob) {
            // for IE
            window.navigator.msSaveBlob(blob, fileName);
        } else {
            if (isSafari) {
                var reader = new window.FileReader();
                reader.onloadend = function() {
                    var dataUrl = reader.result.replace(/^data:[^;]*;/, 'data:attachment;');
                    download(container, fileName, dataUrl);
                };
                reader.readAsDataURL(blob);
            } else {
                // for other browser
                download(container, fileName, window.URL.createObjectURL(blob));
            }
        }
    };
    return {
        createFile: createFile
    }
});


//////////////////
// WEBPACK FOOTER
// ./components/svgchart/src/js/manager/data/export.js
// module id = 18
// module chunks = 0